export enum MessagingUserTypes {
    User = 'user',
    Assistant = 'assistant',
    Bot = 'bot',
}
